import { render, staticRenderFns } from "./noPermission.vue?vue&type=template&id=dbb2828a&scoped=true"
import script from "./noPermission.vue?vue&type=script&lang=js"
export * from "./noPermission.vue?vue&type=script&lang=js"
import style0 from "./noPermission.vue?vue&type=style&index=0&id=dbb2828a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb2828a",
  null
  
)

export default component.exports